

const state = {
    menu: [
    ],
};

export default state
